import { AddCircle } from '@mui/icons-material';
import { Icon } from '@petconsole/pure-shared';
import OurIconButton, { OurIconButtonProps } from './OurIconButton';

interface OurPlusButtonProps extends Omit<OurIconButtonProps, 'tip' | 'Icon'> {
  tip?: string;
  Icon?: Icon;
}

const OurPlusButton = ({ tip = '', Icon = AddCircle, ...rest }: OurPlusButtonProps) => (
  <OurIconButton {...rest} primaryLight tip={tip} Icon={Icon}  />
);

OurPlusButton.whyDidYouRender = true;

export default OurPlusButton;
